<template>
    <CollapsibleWidget>
        <template #name>Languages</template>

        <template #controls>
            <Badge v-if="selectedValues.length" :count="selectedValues.length" class="filter-badge-count" />
        </template>

        <LibraryCheckboxGroup v-model="selectedValues" :options="options" />
    </CollapsibleWidget>
</template>

<script lang="ts">
import LibraryCheckboxGroup from "@/components/Campaign/LibraryCheckboxGroup.vue";
import { DeliverableLibraryAction, DeliverableLibraryGetters } from "@/store/modules/deliverableLibrary";
import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";

export default {
    name: "LibraryLanguageFilter",
    components: {
        CollapsibleWidget,
        LibraryCheckboxGroup
    },

    computed: {
        selectedValues: {
            get() {
                return this.$store.getters[DeliverableLibraryGetters.languageFilters];
            },
            set(newValue: string) {
                this.$store.dispatch(DeliverableLibraryAction.UpdateLanguageFilter, {
                    values: newValue
                });
            }
        },

        options() {
            return this.$store.state.deliverableLibrary.filterOptions.languages;
        }
    }
};
</script>

<style lang="scss">
@use "@style/variables" as *;
</style>
